// import "./textLink.scss"

import { Link } from '@inertiajs/react';
import React from 'react';

interface LinkProps {
    href: string;
    text: string;
    className?: string;
}

const TextLink: React.FC<LinkProps> = ({ href, text, className = '' }) => {
    return (
        <Link href={href} className={`link ${className}`}>
            {text}
        </Link>
    );
};

export default TextLink;
